import React, { FC } from "react";
import BonusDrawListTitle from "../common/listTitles/BonusDrawListTitle";
import { TabbedForm, FormTab } from "react-admin";
import EarlyBirdList from "./EarlyBirdList";
import FlashDraw from "./FlashDraw";

const BonusTabs: FC = () => {
  return (
    <div className="bonus-draw">
      <BonusDrawListTitle />
      <TabbedForm className="user-tabs" toolbar={<></>}>
        <FormTab label="Early Bird Draws">
          <EarlyBirdList />
        </FormTab>
        <FormTab label="Flash Draw">
          <FlashDraw />
        </FormTab>
      </TabbedForm>
    </div>
  );
};

export default BonusTabs;
